import { authenticatedPatch } from '../../../api/request';

export const updatePatientPassword = (data, onFail) => {
  return authenticatedPatch(`/auth/update-password`, onFail, data);
};
